define('casino/providers/nolimit/NoLimitCity',['jquery', 'casino/providers/nolimit/nolimit'], function ($, nolimit) {
	'use strict';

	function NoLimitCity(casino, gameFunctions) {
		if (!(this instanceof NoLimitCity)) {
			throw new TypeError('NoLimitCity constructor cannot be called as a function.');
		}

		this.casino = casino;
		this.gameFunctions = gameFunctions;
	}

	function configuration(noLimitCity, game, options, data) {

		var getUrlParameter = function getUrlParameter(sParam) {
			var sPageURL = decodeURIComponent(window.location.search.substring(1)),
				sURLVariables = sPageURL.split('&'),
				sParameterName,
				i;

			for (i = 0; i < sURLVariables.length; i++) {
				sParameterName = sURLVariables[i].split('=');

				if (sParameterName[0] === sParam) {
					return sParameterName[1] === undefined ? true : sParameterName[1];
				}
			}
		};

		function getToken(data, provider) {
			return data.mode === 'real' ? data.sessionId : '';
		}

		function getEnvironment(providerUrl) {
			return providerUrl.indexOf('partner') !== -1 ? 'partner' : 'casino';
		}

		function launch(options, $game, id) {
			var $targetElement = $("<div/>", {
				id: id
			});
			$targetElement.appendTo($game);
			options = $.extend(options, {
				target: $targetElement[0]
			});
			nolimit.load(options);
		}

		var splitIdAndCode = game.code.split('_');
		if (splitIdAndCode[0] !== 'NLC') {
			throw new Error('Illegal game code not starting with NLC: ' + game.code);
		}

		noLimitCity.gameFunctions.hideHelpButton();
		var provider = noLimitCity.casino.getProvider(game);
		var environment = getEnvironment(provider.url);

		var extraOption = '';
		var campaignId = getUrlParameter('campaignId');
		if (campaignId !== undefined) {
			extraOption = JSON.stringify({ campaignId: campaignId });
		}

		options.launch = {
			options: {
				operator: game.siteCode,
				language: game.localeString,
				device: 'desktop',
				environment: environment,
				currency: data.currency,
				game: splitIdAndCode[1],
				extra: extraOption
			},
			callback: launch
		};

		var token = getToken(data, provider);
		if(token !== '') {
			options.launch.options = $.extend(options.launch.options, {
				token : token
			});
		}

	}

	function freeMode(noLimitCity, game, options) {
		configuration(noLimitCity, game, options, 'free');
		noLimitCity.gameFunctions.switchToFreeMode(game, {
			gameHolder: options.gameHolder,
			type: 'launch',
			launch: options.launch
		});
	}

	function realMode(noLimitCity, game, options, data) {
		configuration(noLimitCity, game, options, data);
		noLimitCity.gameFunctions.verifyCurrency(data.currency);
		noLimitCity.gameFunctions.switchToRealMode(game, {
			gameHolder: options.gameHolder,
			type: 'launch',
			launch: options.launch
		});
	}

	NoLimitCity.prototype = {
		constructor: NoLimitCity,
		freeMode: function (game, options) {
			freeMode(this, game, options);
		},
		realMode: function (game, options, data) {
			realMode(this, game, options, data);
		}
	};
	return NoLimitCity;
});

